module.exports = __webpack_public_path__ + "static/img/Image_Recolor.a6aed15.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Image_Recolor.jpg
// module id = oPIC
// module chunks = 1